import { SupabaseClient } from '@supabase/supabase-js';
import { useQueryWithErrorBoundary, useSupabaseTypedClient } from 'hooks/reactQuery';

import { useCurrentUser } from 'auth/CurrentUserProvider';
import { EdgeFunctionName } from 'types/edgeFunctions';
import { Database } from 'types/supabase';

interface CheckTrialEligibilityResponse {
  isEligible: boolean;
}

interface ICheckTrialEligibilityQueryFnParams {
  supabase: SupabaseClient<Database>;
}

const checkTrialEligibilityQueryFn = async ({
  supabase,
}: ICheckTrialEligibilityQueryFnParams): Promise<CheckTrialEligibilityResponse> => {
  const { data, error } = await supabase.functions.invoke<CheckTrialEligibilityResponse>(
    EdgeFunctionName.CheckTrialEligibility
  );

  if (error) throw error;

  return data!;
};

interface IUseCheckTrialEligibilityResponse {
  isTrialEligible: boolean;
  isPending: boolean;
}

export const useCheckTrialEligibilityQuery = (): IUseCheckTrialEligibilityResponse => {
  const { id: userId } = useCurrentUser();
  const supabase = useSupabaseTypedClient();

  const { data, isPending } = useQueryWithErrorBoundary({
    queryKey: ['check-trial-eligibility', userId],
    queryFn: () => checkTrialEligibilityQueryFn({ supabase }),
    enabled: !!userId,
  });

  return {
    isTrialEligible: data?.isEligible ?? false,
    isPending,
  };
};
